import { Input } from 'almanac-ui/TextInputField/Input'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import Styles from './FromText.module.scss'
import { CONTENT_CHAR_LIMIT } from '../SourceMaterialModal'
import { Text } from 'blaze-ui/Text/Text'
import { CharacterLimitNote } from './CharacterLimitNote'
import { Heading } from 'blaze-ui/Heading/Heading'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

export type FromTextProps = {
  sampleText: string
  showError: boolean
  onChange: (sampleText: string) => void
  fromWebsite?: boolean
  autoFocus?: boolean
}

export const FromText: React.FC<FromTextProps> = ({
  sampleText,
  showError,
  onChange,
  fromWebsite,
  autoFocus = false,
}) => {
  const { isMobile } = useResponsiveDesign()
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const label = fromWebsite
    ? 'Try to copy and paste all the text from your website in the box below'
    : 'Enter text you want to use as source material'

  return (
    <div className={Styles.FromText}>
      <label htmlFor="source-text">
        {isSystemRedesignEnabled ? (
          <Heading level={3}>{label}</Heading>
        ) : (
          <Text variant={isMobile ? 'label' : 'largeList'} color={isMobile ? 'var(--dark-80)' : undefined}>
            {label}
          </Text>
        )}
      </label>
      <div className={Styles.inputContainer}>
        <Input
          value={sampleText}
          onChange={(e) => onChange(e.currentTarget.value)}
          size="xl"
          name="sampleText"
          isTextarea
          resizable={false}
          rows={isSystemRedesignEnabled ? 3 : 8}
          autoFocus={autoFocus}
          maxHeight={isMobile ? 120 : 184}
          id="source-text"
          placeholder="Paste in text"
          errorMessage={showError && !sampleText.length && 'Required'}
          isValid={!(showError && !sampleText)}
          maxLength={CONTENT_CHAR_LIMIT}
        />
        <div className={Styles.texts}>
          <CharacterLimitNote />
          <div className={Styles.charCounter}>
            {sampleText.length}/{CONTENT_CHAR_LIMIT}
          </div>
        </div>
      </div>
    </div>
  )
}
